import { render, staticRenderFns } from "./belong.vue?vue&type=template&id=32a728ec&scoped=true&"
import script from "./belong.vue?vue&type=script&lang=js&"
export * from "./belong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a728ec",
  null
  
)

export default component.exports